<!--

    Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
@if (externeFachstelleResource$ | async; as externeFachstelleResource) {
  <alfa-zustaendige-stelle-header title="Externe Fachstelle" [subTitle]="externeFachstelleResource.name" [isSubTitleBold]="true">
    <ods-icon icon name="external-unit" size="full" />
    <div class="text-text flex flex-1 flex-col text-sm" info>
      <p>{{ externeFachstelleResource.anschrift }}</p>
      <p>{{ 'Email: ' + externeFachstelleResource.email }}</p>
    </div>
    <alfa-edit-zustaendige-stelle-button
      title="Zuständige externe Fachstelle auswählen"
      dataTestId="edit-externe-fachstelle-button"
    />
  </alfa-zustaendige-stelle-header>
} @else {
  <alfa-zustaendige-stelle-header title="Externe Fachstelle" subTitle="Private Organisation, Verein, Schule">
    <ods-icon icon name="external-unit" size="full" />
    <alfa-zustaendige-stelle-button title="Zuständige externe Fachstelle auswählen" dataTestId="externe-fachstelle-button" />
  </alfa-zustaendige-stelle-header>
}
